import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "colored-value-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_ontos_colored_option = _resolveComponent("ontos-colored-option")!

  return (_ctx.form === 'accent')
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "colored-value",
        title: _ctx.option.name
      }, [
        _createVNode(_component_ontos_color_accent, {
          vertical: "",
          color: _ctx.option.color,
          class: "ontos-rel-accent-list"
        }, null, 8, ["color"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.option.name), 1)
      ], 8, _hoisted_1))
    : (_ctx.form === 'person' && _ctx.option.person)
      ? (_openBlock(), _createBlock(_component_ontos_person_line, {
          key: 1,
          dense: "",
          user: _ctx.option.person.user,
          name: _ctx.option.person.name,
          photo: _ctx.option.person.photo
        }, null, 8, ["user", "name", "photo"]))
      : (_openBlock(), _createBlock(_component_ontos_colored_option, {
          key: 2,
          option: _ctx.option,
          dot: _ctx.form === 'dot'
        }, null, 8, ["option", "dot"]))
}